import { useContext, useState, useEffect, useMemo } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import PropsTypes from "prop-types";
import Player from "./players/player";
import PotCard from "./pot/potcard";
import SetChips from "./modals/setchips";
import QrScanner from "./qrscanner/QrScanner";
import UserContext from "../../../context/UserContext";
import socket from "../../../config/socket";
import { client } from "../../../config/keys";
import cardDefault from "../../../assets/images/playerview/card-default1.svg";
import { getResult } from "../../../utils/poker-odds-calculation";
// import ErrorToast from "../../toast/erros";
import ToastError from "../../toast/erros";
import SuccessToast from "../../toast/success";
import ChangeBlinds from "./modals/changeblind";
import NotificationToast from "../../toast/notification";
import { DoDecrypt, DoEncrypt } from "../../../utils";
import ChipsIcon from "../../../assets/images/dealer/chipsColIcon.svg";
import CameraIcon from "../../../IconComponents/CamIcon";
import CommunityCamSetup from "./modals/communityCamSetup";
import ManageWaitingRailModal from "./modals/manageWaitingRailModal";
import CrossIcon from "../../../IconComponents/crossIcon";
import intSignConvert from "../../../utils/intSignConvert";
// import MusicComponent from "../../music";
import MicMute from "../../../IconComponents/MicMute";
import MicUnmute from "../../../IconComponents/MicUnmute";
import HandHistoryIcon from "../../../IconComponents/HandHistoryIcon";

let usedCards1 = [];
let loadingStatus = false;
let gloGameData = {};
let stream;

function PokerTable() {
  const {
    gameData,
    setGameData,
    setAllGamesData,
    user,
    historySidebar,
    setHistorySidebar,
    setDeviceStatus,
    setGameEvent,
    responsiveScale,
    scanCard,
    setScanCard,
    userCamera,
    messages,
    setMessages,
  } = useContext(UserContext);
  const { gameId } = useParams();
  const [players, setPlayers] = useState([]);
  const [winOdds, setWinOdds] = useState([]);
  const [winners, setWinners] = useState([]);
  const [chips, setChips] = useState(false);

  const [cameraError, setCameraError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [changeBlind, setChangeBlind] = useState(false);
  const [reset, setReset] = useState(false);
  const handleResetClose = () => setReset(false);
  const handleResetShow = () => setReset(true);
  const [showWaitingList, setShowWaitingList] = useState(false);
  const [waitingNotification, setWaitingNotification] = useState([]);
  const item = 8;

  const [communityCardSetupModal, setCommunityCardSetupModal] = useState(false);
  const navigate = useNavigate();

  //  Screen Scaling Function Start
  const { scaleValue, topValue } = responsiveScale;

  const handleScanning = () => {
    setScanCard(true);
  };

  const handleChipsClose = () => {
    setChips(false);
  };

  const handleScanCardClose = () => {
    setScanCard(false);
  };

  const handleChipsShow = () => {
    setChips(true);
  };

  const handleBlindsShow = () => {
    setChangeBlind(true);
  };

  const handleBlindsClose = () => {
    setChangeBlind(false);
  };

  const handleRandomScanCard = () => {
    const cards = [];
    const suits = ["H", "S", "C", "D"];
    const values = ["A", 2, 3, 4, 5, 6, 7, 8, 9, "T", "J", "Q", "K"];
    suits.forEach((suit) => {
      values.forEach((value) => {
        cards.push(`${value}${suit}`);
      });
    });
    let socketType = "";
    const { runninground } = gameData;
    if (runninground === 1) {
      socketType = "scanCardForUser";
    } else {
      socketType = "scanCardForCummunity";
    }

    const leftCards = cards?.filter((card) => !usedCards1?.includes(card));
    const card = leftCards[Math.floor(Math.random() * leftCards.length)];
    usedCards1.push(card);
    socket.emit(socketType, { gameId, card: DoEncrypt(card) });
  };

  const handleStartNextGameRound = () => {
    handleScanCardClose();
    if (gameData?.gamestart) {
      socket.emit("startGameAfterCardScan", { gameId });
    }
  };

  const handleResetGame = (keepDealer) => () => {
    socket.emit("resetGame", { gameId, keepDealer });
    setReset(false);
  };

  const startStream = async () => {
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          aspectRatio: { exact: 16 / 9 },
          deviceId:
            JSON.parse(localStorage.getItem("communityCamera"))?.value || "",
        },
      });
      return stream;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error accessing media devices:", error);
      setCameraError(true);
      throw error;
    }
  };

  const allPlayersPot = useMemo(() => {
    if (!gameData) return 0;

    const runningRound = {
      1: "preflopround",
      2: "flopround",
      3: "turnround",
      4: "riverround",
    };

    const roundKey = runningRound[gameData?.runninground];

    if (roundKey && gameData[roundKey]) {
      return (
        gameData[roundKey].reduce(
          (total, player) =>
            total + player.wallet + player.pot + player.prevPot,
          0
        )
        + (gameData.sidePots?.reduce(
          (total, sidePot) => total + sidePot.pot,
          0
        ) || 0)
      );
    }
    if (gameData.players && gameData.players.length) {
      return (
        gameData.players.reduce(
          (total, player) => total + (player.wallet || 0),
          0
        ) || 0
      );
    }

    return 0;
  }, [gameData]);

  useEffect(() => {
    let timeout;

    const handleConnect = () => {
      socket.emit("checkTable", {
        gameId,
        userId: user.id,
      });
    };

    const handleUpdateGame = (data) => {
      const { game, gameEvent, firstStart } = data;

      if (game?.id === gameId) {
        usedCards1 = game?.usedCards?.map((eachCard) => DoDecrypt(eachCard));

        if (gameEvent) {
          setGameEvent(gameEvent);
        }

        setGameData(game);
        setAllGamesData((prev) => ({ ...prev, [game.id]: game }));

        if (!firstStart) {
          loadingStatus = false;
          setLoading(false);
        }
      }
    };

    const handleOnlyOnePlayingPlayer = () => {
      setMessage("Either player do not have chips, or one player is in room");
      setToastType("error");
      loadingStatus = false;
      setLoading(false);
      setTimeout(() => {
        setMessage("");
        setToastType("");
      }, 3000);
    };

    const handleNotFound = (data) => {
      if (
        data.message === "Game not found. Either game is finished or not exist"
      ) {
        navigate("*");
      }
    };

    // card scans on each round socket
    const handleScanCommunityCard = (data) => {
      if (data?.game?.id === gameId) {
        const room = data.game;
        setGameData(room);
        if (room.runninground < 5) {
          handleScanning();
        }
      }
    };

    // card scans on for user  socket
    const handleScanCardForUser = (data) => {
      if (data?.game?.id === gameId) {
        const room = data.game;
        setGameData(room);
        handleScanning();
        loadingStatus = false;
        setLoading(false);
        room.winnerPlayer = [];
        setWinners([]);
      }
    };

    const handleNewHand = (data) => {
      if (data?.game?.id === gameId) {
        const room = data.game;
        gameData.pot = 0;
        gameData.sidePots = [];
        gameData.winnerPlayer = [];
        gameData.runninground = data.game.runninground;
        usedCards1 = [];
        setGameData(room);
        setWinners([]);
        loadingStatus = false;
        setLoading(false);
        room.gamestart = false;
        room.winnerPlayer = [];
      }
    };

    const handleWinner = (data) => {
      if (data?.game?.id === gameId) {
        const room = data.game;
        setGameData(room);
        setWinners(room.winnerPlayer);
        setAllGamesData((prev) => ({ ...prev, [data.game.id]: data.game }));
        loadingStatus = false;
        setLoading(false);
      }
    };

    const handleRoomResumePaused = (data) => {
      if (data?.game?.id === gameId) {
        const room = data.game;
        setGameData(room);
        loadingStatus = false;
        setLoading(false);
      }
    };

    // const handleRoomPaused = (data) => {
    //  if (data?.game?.id === gameId) {
    //    const room = data.game;
    //    setGameData(room);
    //    loadingStatus = false;
    //    setLoading(false);
    //  }
    // };

    socket.on("playerAdded", () => {
      setShowWaitingList(false);
      setDeviceStatus(false);
    });

    const handleWtUpdate = (data) => {
      if (data?.game?.id === gameId) {
        setGameData(data.game);
        const { gameEvent } = data;
        if (gameEvent) {
          setGameEvent(gameEvent);
        }

        if (data.user) {
          // Check if the user is already in waitingNotification
          if (!waitingNotification.some((wP) => wP?.id === data.user.id)) {
            setWaitingNotification((old) => [data.user, ...old]);
            timeout = setTimeout(() => {
              setWaitingNotification((old) => [...old.slice(0, -1)]);
            }, 3000);
          }
        }
      }
    };
    const handleDealerUpdate = (data) => {
      const { gameEvent } = data;
      if (gameEvent) {
        setGameEvent(gameEvent);
      }
    };

    socket.on("connect", handleConnect);
    socket.on("updateGame", handleUpdateGame);
    socket.on("onlyOnePlayingPlayer", handleOnlyOnePlayingPlayer);
    socket.on("notFound", handleNotFound);
    socket.on("scanCommunityCard", handleScanCommunityCard);
    socket.on("scanCardForUser", handleScanCardForUser);
    socket.on("newhand", handleNewHand);
    socket.on("winner", handleWinner);
    socket.on("roomResume", handleRoomResumePaused);
    socket.on("roomPaused", handleRoomResumePaused);
    socket.on("wt-update", handleWtUpdate);
    socket.on("closeScanner", handleScanCardClose);
    socket.on("dealer-update", handleDealerUpdate);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("updateGame", handleUpdateGame);
      socket.off("onlyOnePlayingPlayer", handleOnlyOnePlayingPlayer);
      socket.off("notFound", handleNotFound);
      socket.off("scanCommunityCard", handleScanCommunityCard);
      socket.off("scanCardForUser", handleScanCardForUser);
      socket.off("newhand", handleNewHand);
      socket.off("winner", handleWinner);
      socket.off("roomResume", handleRoomResumePaused);
      socket.off("roomPaused", handleRoomResumePaused);
      socket.off("wt-update", handleWtUpdate);
      socket.off("closeScanner", handleScanCardClose);
      socket.off("dealer-update", handleDealerUpdate);
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const handleCheckTable = () => {
      if (user) {
        socket.emit("checkTable", { gameId, userId: user.id });
      }
    };

    handleCheckTable();

    const tryReconnect = () => {
      setTimeout(() => {
        socket.io.open((err) => {
          if (!err) {
            handleCheckTable();
          }
        });
      }, 2000);
    };

    socket.io.on("close", tryReconnect);

    return () => {
      socket.io.off("close", tryReconnect);
    };
  }, [user, gameId]);

  const getUnique = (arr, index) => {
    const unique = arr
      .map((e) => e[index])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  };
  useEffect(() => {
    if (gameData) {
      if (gameData.runninground >= 1 && !scanCard) {
        const cardOdds = getResult(gameData);
        setWinOdds(cardOdds);
      }
      if (gameData.runninground === 0) {
        const mainPlayers = gameData.players;
        const lobbyplayers = gameData.lobbyPlayers.map((v, index) => ({
          ...v,
          position: mainPlayers.length + index,
          timebank: 0,
          cards: [],
          hands: [],
          action: null,
          actionType: null,
          tentativeAction: null,
          isWatchingIntro: true,
          wallet: 0,
        }));
        const mainPlayer = [...mainPlayers, ...lobbyplayers];
        const filteredPlayer = getUnique(mainPlayer, "id").map((v, index) => ({
          ...v,
          position: index,
        }));
        // setPlayers(mainPlayer);
        setPlayers(filteredPlayer);
      } else if (gameData.runninground === 1) {
        setPlayers(gameData.preflopround);
      } else if (gameData.runninground === 2) {
        setPlayers(gameData.flopround);
      } else if (gameData.runninground === 3) {
        setPlayers(gameData.turnround);
      } else if (gameData.runninground === 4) {
        setPlayers(gameData.riverround);
      } else if (gameData.runninground === 5) {
        setPlayers(gameData.showdown);
      }
    }
  }, [gameData, scanCard]);

  const handleWaitingListShow = () => {
    setShowWaitingList(!showWaitingList);
  };

  const handleMuteAll = () => {
    socket.emit("dealerMuteAll", { gameId });
  };

  gloGameData = gameData;

  const handleCommunityCamSetup = () => {
    setCommunityCardSetupModal(true);
  };

  const handleCommunityCardSetupModalClose = () => {
    setCommunityCardSetupModal(false);
  };

  const waitingPlayersList = useMemo(() => {
    const { waitingPlayers = [], lobbyPlayers = [] } = gameData ?? {};

    const filterPlayers = (source, exclude) =>
      source?.filter(
        (fP) => !exclude?.some((excludeItem) => excludeItem?.id === fP?.id)
      );

    return [
      ...filterPlayers(waitingPlayers, lobbyPlayers),
      ...filterPlayers(lobbyPlayers, waitingPlayers),
    ];
  }, [gameData?.waitingPlayers?.length, gameData?.lobbyPlayers?.length]);

  //  const handleStartDisco = () => {
  //    socket.emit("startSilentDisco", { gameId });
  //  };

  const playerData = useMemo(
    () =>
      [...Array(item).keys()].map((index) => {
        let winOdd;
        const player = players?.find((el) => el.position === index);
        const playerCards = player?.cards?.map((card) => DoDecrypt(card)) || [];
        if (gameData.runninground >= 1) {
          winOdd = winOdds
            ?.find(
              (odd) => odd.getHand()?.toUpperCase() === playerCards.join("")
            )
            ?.getWinsPercentage();
        }
        const winPercentage = `${parseInt(winOdd, 10) || 0}%`;

        return {
          key: index,
          position: index + 1,
          player,
          winOdd: winPercentage,
          winners,
        };
      }),
    [item, players, winOdds, winners]
  );

  const allPlayersMuted = gameData?.players?.every((pl) => !pl?.isAudio);

  useEffect(() => {
    if (navigator.mediaDevices) {
      startStream();
    } else {
      setCameraError(true);
    }
  }, [userCamera]);

  useEffect(() => {
    if (
      (scanCard
        && gameData?.runninground === 2
        && gameData?.communityCard?.length === 3)
      || (scanCard
        && gameData?.runninground === 3
        && gameData?.communityCard?.length === 4)
      || (scanCard
        && gameData?.runninground === 4
        && gameData?.communityCard?.length === 5)
    ) {
      setScanCard(false);
    }
  }, [gameData]);

  return (
    <div className="poker-table">
      {playerData.map((playerInfo) => (
        <Player {...playerInfo} />
      ))}

      <PotCard
        pot={gameData?.pot}
        communityCard={gameData.communityCard}
        sidePots={gameData?.sidePots}
      />
      {gameData?.players?.length >= 2 ? (
        <ActionButton
          handleScanning={handleScanning}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        ""
      )}
      <div className="set-action-btn action-button">
        <ResetButton onClick={handleResetShow} disabled={!gameData.gamestart} />

        {!gameData.gamestart ? (
          <ChangeBlindButton
            onClick={handleBlindsShow}
            disabled={gameData?.gamestart || loading}
          />
        ) : (
          ""
        )}
      </div>

      {!gameData?.gamestart ? (
        <div className="set-chips-btn">
          <span onClick={handleChipsShow} role="presentation">
            Set Chips
          </span>
        </div>
      ) : (
        ""
      )}

      <div className="all-player-pot-wrapper">
        <h3>TOTAL MONEY</h3>
        <div className="total-pot-container">
          <img src={ChipsIcon} alt="Chips Icon" />
          <h4>
            $
            {allPlayersPot || 0}
          </h4>
        </div>
      </div>

      <div className="waiting-list-btn">
        <Button
          className="bg-btn community-card-btn"
          onClick={handleCommunityCamSetup}
        >
          COMMUNITY CARD
          <CameraIcon />
        </Button>
        <Button className="bg-btn table-view">
          <a
            href={`${client}dealer/game/${gameId}`}
            target="_blank"
            rel="noreferrer"
          >
            Table View
          </a>
        </Button>
        <div className="waiting-rail-main-wrapper">
          <Button
            className="bg-btn waiting-btn"
            onClick={handleWaitingListShow}
          >
            {showWaitingList ? <CrossIcon /> : <UserIcon />}
            {waitingPlayersList?.length > 0 && !showWaitingList && (
              <span className="waiting-notification">
                {waitingPlayersList?.length}
              </span>
            )}
          </Button>
          <ManageWaitingRailModal
            showWaitingList={showWaitingList}
            setShowWaitingList={setShowWaitingList}
          />
        </div>
      </div>

      <div className="player-history-btn waiting-list-btn">
        <Button
          className="bg-btn"
          title="Hand's History"
          onClick={() => setHistorySidebar(!historySidebar)}
        >
          <HandHistoryIcon />
        </Button>

        <Button
          className={`bg-btn ${allPlayersMuted ? "" : "player-mute-all-btn"}`}
          title="Mute All Players"
          onClick={handleMuteAll}
          disabled={allPlayersMuted}
        >
          {allPlayersMuted ? <MicUnmute /> : <MicMute />}
        </Button>

        {/* {gameData?.uuid ? (
          <MusicComponent />
        ) : (
          <Button
            className="bg-btn silent-disco-btn"
            onClick={() => handleStartDisco()}
          >
            Start Silent Disco
          </Button>
        )} */}
      </div>

      <Modal
        show={changeBlind}
        onHide={handleBlindsClose}
        centered
        className="poker-popup set-chips-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Change blinds</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChangeBlinds handleBlindsClose={handleBlindsClose} />
        </Modal.Body>
      </Modal>

      <Modal
        show={reset}
        onHide={handleResetClose}
        centered
        className="bar-room-leave-popup"
      >
        <div className="bar-room-leave">
          <p>Are you sure you want to reset the round?</p>
          <div className="bar-room-leave-btn">
            <Button className="bg-btn" onClick={handleResetGame(false)}>
              Yes, and advance dealer
            </Button>
            <Button className="bg-btn" onClick={handleResetGame(true)}>
              Yes, and keep dealer
            </Button>
            <Button className=" bg-btn outline-btn" onClick={handleResetClose}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        show={chips}
        onHide={handleChipsClose}
        centered
        className="poker-popup set-chips-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Set Chips</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SetChips handleChipsClose={handleChipsClose} />
        </Modal.Body>
      </Modal>

      <Modal
        className={`poker-popup card-scaning-popup ${
          scanCard ? "open" : "close"
        }`}
        show={scanCard}
        onHide={handleScanCardClose}
        backdrop="static"
        backdropClassName={scanCard ? "open" : "close"}
        style={{
          transform: `translate(-50%, ${intSignConvert(topValue) + 4}%) scale(${
            scaleValue / 100 - 0.15
          })`,
        }}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Card scanning</Modal.Title>
          <Modal.Title>
            Total Players
            <span style={{ color: "#83bc9a", paddingLeft: "4px" }}>
              {gameData?.players?.filter((pl) => pl.playing)?.length}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {gameData?.runninground === 2 ? (
            <div className="scan-cards">
              {[0, 1, 2].map((card) =>
                (gameData?.communityCard[card] ? (
                  <span key={card}>
                    <img
                      src={`${client}main-view-cards/${DoDecrypt(
                        gameData?.communityCard[card]
                      )}.svg`}
                      alt="CPN Card"
                    />
                  </span>
                ) : (
                  <span key={card} />
                ))
              )}
              <span>
                <img src={cardDefault} alt="Default CPN Card" />
              </span>
              <span>
                <img src={cardDefault} alt="Default CPN Card" />
              </span>
            </div>
          ) : gameData.runninground === 3 ? (
            <div className="scan-cards">
              {[0, 1, 2, 3].map((card) =>
                (gameData?.communityCard[card] ? (
                  <span key={card}>
                    <img
                      src={`${client}main-view-cards/${DoDecrypt(
                        gameData?.communityCard[card]
                      )}.svg`}
                      alt="CPN Card"
                    />
                  </span>
                ) : (
                  <span key={card} />
                ))
              )}
              <span>
                <img src={cardDefault} alt="Default CPN Card" />
              </span>
            </div>
          ) : gameData.runninground === 4 ? (
            <div className="scan-cards">
              {[0, 1, 2, 3, 4].map((card) =>
                (gameData?.communityCard[card] ? (
                  <span key={card}>
                    <img
                      src={`${client}main-view-cards/${DoDecrypt(
                        gameData?.communityCard[card]
                      )}.svg`}
                      alt="CPN Card"
                    />
                  </span>
                ) : (
                  <span key={card} />
                ))
              )}
            </div>
          ) : (
            ""
          )}

          {cameraError ? (
            <div className="camera-not-found">
              <div>
                <h4>Camera not found</h4>
                <p>Check the connection</p>
                <p
                  onClick={() => handleRandomScanCard()}
                  role="presentation"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  click me for random card flow for test
                </p>
              </div>
            </div>
          ) : (
            <div className="qr-scanner">
              <QrScanner
                setCameraError={setCameraError}
                gameData={gameData}
                usedCards={usedCards1}
                stream={stream}
              />
            </div>
          )}
          <Button onClick={handleStartNextGameRound}>
            {(() => {
              if (!gameData?.gamestart) return "Finish scanning";
              if (
                gameData?.gamestart
                && gameData?.communityCard?.length === 0
              ) {
                return "Start Preflop round";
              }
              if (gameData?.gamestart && gameData?.communityCard?.length <= 3) {
                return "Start Flop round";
              }
              if (gameData?.gamestart && gameData?.communityCard?.length <= 4) {
                return "Start Turn round";
              }
              if (gameData?.gamestart && gameData?.communityCard?.length <= 5) {
                return "Start River round";
              }
              return "";
            })()}
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        show={communityCardSetupModal}
        onHide={handleCommunityCardSetupModalClose}
        centered
        className="poker-popup community-cam-setup-modal"
        size="lg"
        style={{
          transform: `translate(-50%, ${intSignConvert(topValue)}%) scale(${
            scaleValue / 100
          })`,
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>COMMUNITY CARD</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <SetChips handleChipsClose={handleChipsClose} /> */}
          <CommunityCamSetup
            handleCommunityCardSetupModalClose={
              handleCommunityCardSetupModalClose
            }
          />
        </Modal.Body>
      </Modal>

      {toastType === "error" ? (
        <ToastError
          message={message}
          closeAction={() => {
            setMessage("");
            setToastType("");
          }}
        />
      ) : toastType === "success" ? (
        <SuccessToast message={message} />
      ) : (
        ""
      )}
      <div className="notification-wrapper">
        {waitingNotification.map((notification) => (
          <NotificationToast key={notification?.id} name={notification?.name} />
        ))}
      </div>
      {messages?.map((message1) => {
        if (message1.type === "error") {
          setTimeout(() => {
            setMessages((old) => old.filter((o) => o.id !== message1.id));
          }, 4000);
          return (
            <ToastError
              key={message1.id}
              message={message1.msg}
              closeAction={() =>
                setMessages((old) => old.filter((o) => o.id !== message1.id))}
            />
          );
        }
        return "";
      })}
    </div>
  );
}

export default PokerTable;

function ActionButton({ handleScanning, setLoading, loading }) {
  const { gameData } = useContext(UserContext);
  const handleGameStart = () => {
    socket.emit("startGame", { gameId: gameData?.id });
    loadingStatus = true;
    setLoading(true);
  };
  const handlePauseGame = () => {
    socket.emit("pauseGame", { gameId: gameData?.id });
    loadingStatus = true;
    setLoading(true);
  };

  const handleResumeGame = () => {
    socket.emit("resumeGame", { gameId: gameData?.id });
    loadingStatus = true;
    setLoading(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === " " && !(loadingStatus || gloGameData?.gamestart)) {
        handleGameStart();
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [loading, gloGameData?.gamestart]);

  const isPauseButtonDisabled = gameData.pause
    || loading
    || gameData?.preflopround.some(
      (player) => player?.cards?.length !== 2 && player.playing
    )
    || (gameData?.runninground === 2 && gameData?.communityCard.length !== 3)
    || (gameData?.runninground === 3 && gameData?.communityCard.length !== 4)
    || (gameData?.runninground === 4 && gameData?.communityCard.length !== 5);

  return (
    <div className="action-button">
      <div className="scan-btn">
        <Button
          onClick={handleScanning}
          disabled={
            !gameData?.gamestart
            || gameData?.pause
            || gameData?.runninground === 5
          }
        >
          Start Scanning
        </Button>
      </div>
      <div className="start-hand-btn">
        {!gameData.gamestart ? (
          <Button
            onClick={handleGameStart}
            disabled={gameData?.gamestart || loading}
          >
            {loading ? <Spinner animation="border" /> : "Start Hand"}
          </Button>
        ) : !gameData.pause ? (
          <Button onClick={handlePauseGame} disabled={isPauseButtonDisabled}>
            {loading ? <Spinner animation="border" /> : "Pause the game"}
          </Button>
        ) : (
          <Button onClick={handleResumeGame} disabled={loading}>
            {loading ? <Spinner animation="border" /> : "Resume the game"}
          </Button>
        )}
      </div>
    </div>
  );
}
ActionButton.propTypes = {
  handleScanning: PropsTypes.func.isRequired,
  loading: PropsTypes.bool.isRequired,
  setLoading: PropsTypes.func.isRequired,
};

function ResetButton({ onClick, disabled }) {
  return (
    <div className="reset-button">
      <div className="reset-table-btn start-hand-btn scan-btn">
        <Button onClick={onClick} disabled={disabled}>
          Reset round
        </Button>
      </div>
    </div>
  );
}

ResetButton.propTypes = {
  onClick: PropsTypes.func.isRequired,
  disabled: PropsTypes.bool.isRequired,
};

function ChangeBlindButton({ onClick, disabled }) {
  return (
    <div className="change-blind-button">
      <div className="reset-table-btn start-hand-btn">
        <Button onClick={onClick} disabled={disabled}>
          Change Blinds
        </Button>
      </div>
    </div>
  );
}

ChangeBlindButton.propTypes = {
  onClick: PropsTypes.func.isRequired,
  disabled: PropsTypes.bool.isRequired,
};

function UserIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5790_2830)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75267 5.79537C8.04566 5.79537 7.36762 6.08262 6.86769 6.59391C6.36776 7.10521 6.0869 7.79867 6.0869 8.52175C6.0869 9.24483 6.36776 9.9383 6.86769 10.4496C7.36762 10.9609 8.04566 11.2481 8.75267 11.2481C9.45968 11.2481 10.1377 10.9609 10.6377 10.4496C11.1376 9.9383 11.4184 9.24483 11.4184 8.52175C11.4184 7.79867 11.1376 7.10521 10.6377 6.59391C10.1377 6.08262 9.45968 5.79537 8.75267 5.79537ZM4.08758 8.52175C4.08748 7.73093 4.27959 6.95248 4.64663 6.25643C5.01366 5.56038 5.54411 4.96854 6.19027 4.53417C6.83643 4.09979 7.57802 3.83649 8.34835 3.76795C9.11869 3.69941 9.8936 3.82778 10.6034 4.14152C11.3132 4.45525 11.9356 4.94451 12.4146 5.56528C12.8937 6.18605 13.2143 6.91888 13.3478 7.69784C13.4812 8.4768 13.4232 9.27746 13.1791 10.0278C12.9349 10.7782 12.5122 11.4547 11.9489 11.9965C13.011 12.5235 13.9332 13.3047 14.6372 14.2739C15.3412 15.2431 15.8062 16.3716 15.9929 17.5638C16.0135 17.6964 16.0083 17.8319 15.9776 17.9625C15.947 18.0931 15.8915 18.2163 15.8144 18.325C15.7372 18.4336 15.6398 18.5257 15.5279 18.5959C15.4159 18.6661 15.2915 18.7131 15.1618 18.7341C15.0321 18.7551 14.8997 18.7498 14.772 18.7185C14.6443 18.6872 14.5238 18.6304 14.4176 18.5515C14.3113 18.4726 14.2213 18.373 14.1527 18.2585C14.084 18.144 14.0381 18.0168 14.0176 17.8841C13.8159 16.6046 13.1752 15.4403 12.2105 14.6C11.2457 13.7596 10.0199 13.2981 8.75267 13.2981C7.48543 13.2981 6.2596 13.7596 5.29484 14.6C4.33009 15.4403 3.68947 16.6046 3.48778 17.8841C3.46712 18.0168 3.42113 18.144 3.35241 18.2585C3.28369 18.3729 3.1936 18.4724 3.08728 18.5513C2.98097 18.6302 2.8605 18.6868 2.73277 18.7181C2.60503 18.7493 2.47253 18.7545 2.34283 18.7334C2.21313 18.7123 2.08876 18.6652 1.97684 18.595C1.86491 18.5247 1.76762 18.4325 1.69051 18.3238C1.6134 18.2151 1.55799 18.0919 1.52744 17.9612C1.49688 17.8306 1.49179 17.6951 1.51244 17.5624C1.69949 16.3707 2.16472 15.2428 2.8687 14.2741C3.57267 13.3054 4.49463 12.5246 5.55641 11.9979C5.09194 11.5522 4.72191 11.0137 4.46925 10.4157C4.21659 9.81778 4.08668 9.17314 4.08758 8.52175V8.52175ZM16.0835 6.47697C15.8184 6.47697 15.5641 6.58468 15.3767 6.77642C15.1892 6.96816 15.0839 7.22821 15.0839 7.49936C15.0839 7.77052 15.1892 8.03057 15.3767 8.2223C15.5641 8.41404 15.8184 8.52175 16.0835 8.52175C16.5345 8.52178 16.9722 8.67774 17.3256 8.96431C17.679 9.25088 17.9273 9.65122 18.0301 10.1003C18.1329 10.5494 18.0843 11.0208 17.892 11.4381C17.6998 11.8553 17.3753 12.1939 16.9712 12.3987C16.8046 12.4834 16.6644 12.6141 16.5664 12.7759C16.4685 12.9378 16.4166 13.1244 16.4168 13.3147V13.7946C16.4165 14.0242 16.4918 14.2473 16.6306 14.4278C16.7694 14.6083 16.9636 14.7358 17.1818 14.7897C18.7813 15.1837 20.0635 16.4255 20.5434 18.0232C20.5814 18.1521 20.644 18.272 20.7275 18.3761C20.811 18.4802 20.9138 18.5664 21.03 18.6297C21.1461 18.6931 21.2734 18.7324 21.4044 18.7453C21.5355 18.7582 21.6677 18.7445 21.7936 18.705C21.9194 18.6655 22.0364 18.601 22.1378 18.5151C22.2392 18.4293 22.3231 18.3238 22.3845 18.2047C22.4459 18.0856 22.4838 17.9553 22.4958 17.8212C22.5079 17.6871 22.4939 17.5519 22.4547 17.4234C22.188 16.5381 21.7479 15.7176 21.1613 15.0117C20.5747 14.3058 19.8538 13.7294 19.0425 13.3175C19.5636 12.7312 19.907 12.0028 20.0309 11.2207C20.1548 10.4386 20.0539 9.63652 19.7405 8.91197C19.4271 8.18742 18.9146 7.57158 18.2654 7.1393C17.6162 6.70703 16.8582 6.47693 16.0835 6.47697V6.47697Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5790_2830">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
